import api from './api'

export const capstoneService = {
  // Get all capstones
  getAll: async () => {
    const response = await api.get('/capstones')
    // Handle both response.data.capstones (object wrapper) and response.data (direct array)
    return response.data.capstones || response.data || []
  },

  // Get single capstone
  getById: async (id) => {
    const response = await api.get(`/capstones/${id}`)
    return response.data.capstone
  },

  // Get capstones by module
  getByModule: async (moduleId) => {
    const response = await api.get(`/capstones?module_id=${moduleId}`)
    return response.data
  },

  // Submit capstone
  submit: async (id, submissionData) => {
    // Ensure github_repo_url is included if provided
    const payload = {
      content: submissionData.content || null,
      github_repo_url: submissionData.github_repo_url || null,
      notes: submissionData.notes || null,
      files: submissionData.files || [],
    }
    const response = await api.post(`/capstones/${id}/submit`, payload)
    return response.data
  },

  // Verify GitHub repository and fetch metadata
  verifyGithubRepo: async (githubUrl) => {
    const response = await api.post('/capstones/verify-github', {
      github_url: githubUrl,
    })
    return response.data
  },

  // Get or create draft submission
  getDraftSubmission: async (id) => {
    const response = await api.get(`/capstones/${id}/submission/draft`)
    return response.data
  },

  // Update progress
  updateProgress: async (id, progressData) => {
    const response = await api.post(`/capstones/${id}/progress`, progressData)
    return response.data
  },

  // Time Tracking
  startTimer: async (id) => {
    const response = await api.post(`/capstones/${id}/time/start`)
    return response.data
  },

  stopTimer: async (id) => {
    const response = await api.post(`/capstones/${id}/time/stop`)
    return response.data
  },

  getTimeData: async (id) => {
    const response = await api.get(`/capstones/${id}/time`)
    return response.data
  },

  getTimeAnalytics: async () => {
    const response = await api.get('/time-analytics')
    return response.data
  },
}
